import { Link } from "react-router-dom";
import { Table } from "components/ui";
import { formatDate } from "utils/helper";
import {
    AUTOMATION_ACTION_LABELS,
    AUTOMATION_TABLE_HEADERS,
} from "../enum";
import AutomationsStatusSwitch from "../AutomationsStatusSwitch/AutomationsStatusSwitch";
import AutomationsTableActions from "../AutomationsTableActions/AutomationsTableActions";

const AutomationsTable = ({
    automations,
    tableIsLoading,
    handleActionModal,
    getAutomations,
}) => {
    const tableData = automations?.map((automation) => {
        const {
            automationId,
            name,
            status,
            actionType,
            createdDate,
            updatedDate,
        } = automation;

        return {
            name: (
                <Link
                    to={`/t-sam/automation/${automationId}`}
                    className='td-href'>
                    {name}
                </Link>
            ),
            status: (
                <AutomationsStatusSwitch
                    automationId={automationId}
                    status={status}
                    getAutomations={getAutomations}
                />
            ),
            action: AUTOMATION_ACTION_LABELS[actionType] || actionType,
            created: formatDate(createdDate) || "—",
            updated: formatDate(updatedDate) || "—",
            actions: (
                <div className='discovery--actions'>
                    <AutomationsTableActions
                        automation={automation}
                        handleActionModal={handleActionModal}
                    />
                </div>
            ),
        };
    });

    return (
        <Table
            headers={AUTOMATION_TABLE_HEADERS}
            dataSource={tableData}
            isLoading={tableIsLoading}
        />
    );
};

export default AutomationsTable;
